import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../../context/axios";
import { FaWhatsappSquare, FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("/categories");
        setCategories(response.data || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="w-full bg-black py-16 px-10 grid md:grid-cols-3 gap-8 text-gray-300 bottom-0">
      <div>
        <h3 className="text-2xl font-bold text-[#41A4FF]">TripNest</h3>
        <p className="py-4 text-gray-600">
          Your trusted travel partner. We help you explore the world with ease
          and joy.
        </p>
        <p className="py-1 text-gray-700">
          <strong>Email:</strong> holidays.tripnest@gmail.com
        </p>
        <p className="py-1 text-gray-700">
          <strong>Phone:</strong> +49 1512 3456789
        </p>
        <div className="flex justify-start gap-8 md:w-[75%] my-6 text-[#41A4FF]">
          <a
            href="https://wa.me/15123456789"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
          >
            <FaWhatsappSquare
              size={30}
              className="cursor-pointer hover:text-green-500"
            />
          </a>
          <a
            href="mailto:holidays.tripnest@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Send Email"
          >
            <FaEnvelope
              size={30}
              className="cursor-pointer hover:text-red-500"
            />
          </a>
        </div>
      </div>

      <div>
        <h6 className="font-bold text-[#41A4FF] mb-4">Categories</h6>
        <ul>
          {categories.length > 0 ? (
            categories.slice(0, 8).map((cat) => (
              <li key={cat._id} className="py-1">
                <Link
                  onClick={() => window.scrollTo(0, 0)}
                  to={`/packagelist?category=${cat._id}`}
                  className="hover:underline"
                >
                  {cat.title || cat.name}
                </Link>
              </li>
            ))
          ) : (
            <li>No categories available</li>
          )}
        </ul>
      </div>

      <div>
        <h6 className="font-bold text-[#41A4FF] mb-4">Support</h6>
        <ul>
          <li className="py-2 text-sm">
            <Link
              onClick={() => window.scrollTo(0, 0)}
              to="/contactus"
              className="hover:underline"
            >
              Contact us
            </Link>
          </li>
          <li className="py-2 text-sm">
            <Link
              onClick={() => window.scrollTo(0, 0)}
              to="/packagelist"
              className="hover:underline"
            >
              Reservations
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
